import { PositionCategoriesState } from "./flyer-detail-page-form-position-categories.interface";

export function flyerDetailPageFormPositionCategoriesState(): PositionCategoriesState {
  return {
    categories: null,
    error: null,
    loading: false,
  };
}
